import { LineChart } from 'lucide-react';

interface Props {
  title: string;
  subtitle: string;
}

/**
 * Friendly "no trend data yet" card rendered in place of an axes-only
 * ECharts frame across the three ExperimentTrendChart consumers
 * (Performance panel, Daily-Lift table, In-Stock trends). Pulls i18n copy
 * from the consumer so each surface can tailor the message.
 */
export function ExperimentTrendEmptyState({ title, subtitle }: Props) {
  return (
    <div
      role="status"
      className="border-muted bg-muted/30 flex h-80 w-full flex-col items-center justify-center gap-2 rounded-md border border-dashed text-center"
    >
      <LineChart className="text-muted-foreground h-10 w-10" aria-hidden />
      <p className="text-foreground text-base font-medium">{title}</p>
      <p className="text-muted-foreground max-w-md text-sm">{subtitle}</p>
    </div>
  );
}
